import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhoto = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_892_20048",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_892_20048)",
		children: /* @__PURE__ */ _jsx("path", { d: "M12 17.1153C13.1474 17.1153 14.1202 16.7163 14.9182 15.9182C15.7163 15.1202 16.1153 14.1474 16.1153 13C16.1153 11.8525 15.7163 10.8798 14.9182 10.0817C14.1202 9.28366 13.1474 8.88462 12 8.88462C10.8525 8.88462 9.87979 9.28366 9.08173 10.0817C8.28366 10.8798 7.88462 11.8525 7.88462 13C7.88462 14.1474 8.28366 15.1202 9.08173 15.9182C9.87979 16.7163 10.8525 17.1153 12 17.1153ZM12 15.6154C11.2615 15.6154 10.641 15.3641 10.1384 14.8615C9.63586 14.359 9.38458 13.7384 9.38458 13C9.38458 12.2615 9.63586 11.641 10.1384 11.1384C10.641 10.6359 11.2615 10.3846 12 10.3846C12.7384 10.3846 13.359 10.6359 13.8615 11.1384C14.3641 11.641 14.6154 12.2615 14.6154 13C14.6154 13.7384 14.3641 14.359 13.8615 14.8615C13.359 15.3641 12.7384 15.6154 12 15.6154ZM4.3077 20.5C3.80257 20.5 3.375 20.325 3.025 19.975C2.675 19.625 2.5 19.1974 2.5 18.6923V7.3077C2.5 6.80257 2.675 6.375 3.025 6.025C3.375 5.675 3.80257 5.5 4.3077 5.5H7.36153L9.21153 3.5H14.7884L16.6384 5.5H19.6923C20.1974 5.5 20.625 5.675 20.975 6.025C21.325 6.375 21.5 6.80257 21.5 7.3077V18.6923C21.5 19.1974 21.325 19.625 20.975 19.975C20.625 20.325 20.1974 20.5 19.6923 20.5H4.3077ZM19.6923 19C19.782 19 19.8557 18.9711 19.9134 18.9134C19.9711 18.8557 20 18.782 20 18.6923V7.3077C20 7.21795 19.9711 7.14423 19.9134 7.08653C19.8557 7.02883 19.782 6.99998 19.6923 6.99998H15.9692L14.1346 4.99997H9.86535L8.03075 6.99998H4.3077C4.21795 6.99998 4.14423 7.02883 4.08653 7.08653C4.02883 7.14423 3.99998 7.21795 3.99998 7.3077V18.6923C3.99998 18.782 4.02883 18.8557 4.08653 18.9134C4.14423 18.9711 4.21795 19 4.3077 19H19.6923Z" })
	})]
});
export default SvgPhoto;
